import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "registration-personal" }
const _hoisted_2 = { class: "registration-personal__credentials" }
const _hoisted_3 = {
  id: "consents",
  class: "registration-personal__consents"
}

import { ref } from "vue";
import { ConsentDto } from "@/account/models/registration/consent-dto";
import useRegistrationConsents from "@/account/composables/use-registration-consents";

import NewPasswordInput from "@/account/components/inputs/new-password-input.vue";
import PhoneInput from "@/account/components/inputs/phone-input.vue";
import CheckboxInput from "@/account/components/inputs/checkbox-input.vue";
import { authenticationErrors, authenticationData } from "@/account/composables/use-authentication-data";
import { dataLayerRegistrationError } from "@/data-layer/services/actions";


export default /*@__PURE__*/_defineComponent({
  __name: 'registration-personal',
  setup(__props, { expose: __expose }) {

const { getDisplayedConsets } = useRegistrationConsents();

const phoneInputRef = ref(null);
const newPasswordInputRef = ref(null);
const checkboxRef = ref([]);

getDisplayedConsets().then((data: ConsentDto[]) => {
    authenticationData.consents = data;
});

const checkIfIsValid = () => {
    const consentsAreValid = checkboxRef.value.every((checkboxValidation) => checkboxValidation.checkIfIsValid());
    const phoneIsValid = phoneInputRef.value.checkIfIsValid();
    const newPasswordIsValid = newPasswordInputRef.value.checkIfIsValid();

    return consentsAreValid && phoneIsValid && newPasswordIsValid;
};

__expose({
    checkIfIsValid,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(PhoneInput, {
        ref_key: "phoneInputRef",
        ref: phoneInputRef,
        class: "registration-personal__phone",
        modelValue: _unref(authenticationData).userName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(authenticationData).userName) = $event)),
        name: "phone",
        title: "Telefonní číslo",
        "show-tooltip": true,
        placeholder: "Zadejte své telefonní číslo",
        "error-message": _unref(authenticationErrors).phoneErrorMessage,
        "onUpdate:errorMessage": _cache[1] || (_cache[1] = ($event: any) => ((_unref(authenticationErrors).phoneErrorMessage) = $event)),
        onInputErrorDetected: _unref(dataLayerRegistrationError)
      }, null, 8, ["modelValue", "error-message", "onInputErrorDetected"]),
      _createVNode(NewPasswordInput, {
        class: "registration-personal__password",
        ref_key: "newPasswordInputRef",
        ref: newPasswordInputRef,
        modelValue: _unref(authenticationData).password,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(authenticationData).password) = $event)),
        name: "password",
        "error-message": _unref(authenticationErrors).passwordErrorMessage,
        "onUpdate:errorMessage": _cache[3] || (_cache[3] = ($event: any) => ((_unref(authenticationErrors).passwordErrorMessage) = $event)),
        onInputErrorDetected: _unref(dataLayerRegistrationError)
      }, null, 8, ["modelValue", "error-message", "onInputErrorDetected"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(authenticationData).consents, (consent) => {
        return (_openBlock(), _createBlock(CheckboxInput, {
          class: "registration-personal__consent",
          ref_for: true,
          ref_key: "checkboxRef",
          ref: checkboxRef,
          key: `consent-${consent.id}`,
          name: consent.id,
          modelValue: consent.enabled,
          "onUpdate:modelValue": ($event: any) => ((consent.enabled) = $event),
          description: consent.description,
          mandatory: consent.mandatory
        }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "description", "mandatory"]))
      }), 128))
    ])
  ]))
}
}

})